namespace B2B.Retarget {
    // rt_form_open - открытие формы
    export const FormOpen = "rt_form_open";

    // rt_form_interaction - взаимодействие с формой
    export const FormInteraction = "rt_form_interaction";

    // rt_catalog_open - открытие каталога
    export const CatalogOpen = "rt_catalog_open";

    // rt_form_calc_interaction - взаимодействие с калькулятором
    export const FormCalcInteraction = "rt_form_calc_interaction";

    // rt_case_view - просматр кейсов
    export const CaseView = "rt_case_view";

    // rt_form_howtoget_open - открытие формы выбора email/whatsup
    export const FormHowToGetOpen = "rt_form_howtoget_open";
}